'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var teal7 = exports.teal7 = '#00867F';
var teal6 = exports.teal6 = '#009E95';
var teal5 = exports.teal5 = '#27ADA6';
var teal4 = exports.teal4 = '#4DBCB6';
var teal3 = exports.teal3 = '#68C8C2';
var teal2 = exports.teal2 = '#81D4CE';
var teal1 = exports.teal1 = '#9BE0DA';
var teal = {
  7: teal7,
  6: teal6,
  5: teal5,
  4: teal4,
  3: teal3,
  2: teal2,
  1: teal1
};
exports.default = teal;